import { gql } from "@apollo/client"

export const CHANGE_PARTNERSHIP_TIER_QUERY = gql`
    query ChangePartnershipTierQuery($recruitingTeam: String!) {
        recruitingTeam(uuid: $recruitingTeam) {
            id
            customer {
                id
                paymentMethods {
                    id
                }
            }
        }
    }
`
